import { type HTMLAttributes } from 'react';
import { cn } from '../../lib/utils.js';

export type BadgeTone = 'neutral' | 'success' | 'warn' | 'danger' | 'info' | 'ai';

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-[var(--app-divider)] text-[var(--fg-2)]',
  success: 'bg-[var(--brand-100)] text-[var(--brand-800)]',
  warn: 'bg-[var(--accent-highlight)] text-[var(--ink-900)]',
  danger: 'bg-[var(--st-rejected-bg)] text-[var(--st-rejected-fg)]',
  info: 'bg-[var(--st-content-review-bg)] text-[var(--st-content-review-fg)]',
  ai: 'bg-[var(--ai-bg)] text-[var(--ai-fg)]',
};

export function Badge({
  tone = 'neutral',
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: BadgeTone }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2.5 py-0.5 text-meta font-medium leading-tight',
        tones[tone],
        className,
      )}
      {...props}
    />
  );
}
